/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import { get } from 'lodash';
import styles from './gateway.styles';
import { userIsLoggedIn, getUrlParams, isLocal, userHasRole, getDefaultLanding } from '../actions/utils';
import { getUserData } from '../authentication/authentication.actions';
import { getUser } from '../_shared/services/manage-users.service';
import { getPublicRoutes } from '../dashboard/dashboard.routes';

export class GateWayComponent extends Component {
  state = { thinking: true, redirect: null };
  componentDidMount = async () => {
    const { sState, history: { location } } = this.props;
    if (userIsLoggedIn(sState)) {
      this.props.getUserData()
        .then(async () => {
          if (location.pathname === '/validateUser') {
            const { email } = getUrlParams(window.location.href);
            const editAccount = await getUser(email, { returnRaw: true });
            this.props.history.push('/dashboard/editAccount', {
              editAccount,
            });
            this.setState({ thinking: false });
          } else if (location.pathname.indexOf('/order/') > -1) {
            const [, id] = location.pathname.split('/order/');
            const isAdmin = userHasRole([0, 1], this.props.sState);
            const isDriver = userHasRole(2, this.props.sState);
            //http://localhost:3000/order/f7314f8c-30be-448a-8739-921a2110f878
            this.redirect(`/dashboard/${isAdmin ? 'adminManageOrders' : isDriver ? 'manageSchedule' : 'orders'}?id=${id}`);
          } else if (location.pathname.indexOf('/recon/') === 0) {
            // Card #283 — a scanned Recon Form QR deep-links straight to
            // /recon/:id. Keep the path so that page can resolve the
            // reconciliation's order, instead of bouncing the user to their
            // default landing.
            this.redirect(`${location.pathname}${location.search}`);
          } else if (location.pathname.indexOf('/dashboard/') === 0 && location.pathname !== '/dashboard/') {
            // Deep links into the app (e.g. the emailed
            // /dashboard/orders?search=<id> links) keep their path + query on a
            // fresh page load instead of being bounced to the default landing.
            // Each screen's own guards still apply; bare /dashboard falls
            // through to the default landing below. (card #151)
            this.redirect(`${location.pathname}${location.search}`);
          } else {
            // Default landing on every app mount — both initial login and a
            // page refresh (the gateway runs on mount/refresh only, so in-app
            // navigation still works normally). Configurable per role via the
            // defaultLanding.role_<N> settings; falls back to the historical
            // behavior (0/1 -> Admin Dashboard, 2 -> Schedules, else
            // /dashboard). Role is read from the *latest* props — getUserData()
            // above hydrates it.
            const role = get(this.props, 'sState.user.role');
            this.redirect(getDefaultLanding(role));
          }
        })
        .catch(() => {
          const role = get(this.props, 'sState.user.role');
          this.redirect(getDefaultLanding(role));
        });
    } else {
      const publicRoutes = getPublicRoutes().map(r => r.path);

      if (publicRoutes.indexOf(location.pathname) > -1) {
        return this.redirect(`${location.pathname}${location.search}`);
      }

      // Public auth screens reachable via emailed links (no session yet):
      // the Forgot Password screen and the reset-token submit screen
      // (/forgotPasswordSubmit?token=...). Without this, a fresh page load on
      // the emailed reset link would be bounced to /login before the token
      // could be read. (card #160)
      const publicAuthPaths = ['/forgotPassword', '/forgotPasswordSubmit'];
      if (publicAuthPaths.indexOf(location.pathname) > -1) {
        return this.redirect(`${location.pathname}${location.search}`);
      }

      // Card #283 — an unauthenticated scan of a Recon Form QR. Send them to
      // login, but carry the deep link so they land back on the
      // reconciliation's order afterwards rather than on the dashboard having
      // to rescan the form.
      if (location.pathname.indexOf('/recon/') === 0) {
        this.props.history.push('/login', {
          redirectTo: `${location.pathname}${location.search}`,
        });
        return this.setState({ thinking: false });
      }

      if (location.pathname === '/signMeUp') {
        const { email } = getUrlParams(window.location.href);

        this.props.history.push('/signup', {
          email,
          fromLink: true,
        });
        this.setState({ thinking: false });
      } else {
        this.redirect('/login');
      }
    }
  };
  redirect = (loc) => {
    this.setState({ 
      redirect: isLocal ? undefined : loc, 
      thinking: false 
    });
  };
  render() {
    const { redirect, thinking } = this.state;

    if (redirect) {
      return <Redirect to={redirect || '/'} />;
    }

    return thinking ? (
      <div css={css(styles.thinkWrap)}>
        <Icon type="loading" css={css(styles.icon)} />
      </div>
    ) : null;
  }
}

export default connect(
  (sState) => ({ sState })
, {
  getUserData
})(withRouter(GateWayComponent));
